export const MARKET_MODELING_PERSONAS = {
  APP: 'APP',
  PHY: 'Phy',
}

export const MARKET_MODELING_SCENARIO_CODES = {
  CONSERVATIVE: 'conservative',
  MODERATE: 'moderate',
  OPTIMIZED: 'optimized',
  CUSTOM: 'custom',
}

const PERSONA_THEMES = {
  [MARKET_MODELING_PERSONAS.APP]: {
    accentColor: '#F28C28',
    accentSoftColor: '#FFF2E4',
    metricValueColor: '#F28C28',
    modeledBorderColor: '#F7C089',
  },
  [MARKET_MODELING_PERSONAS.PHY]: {
    accentColor: '#0076BE',
    accentSoftColor: '#EBF6FE',
    metricValueColor: '#0076BE',
    modeledBorderColor: '#9CCEEE',
  },
}

const SCENARIO_TAB_DEFINITIONS = [
  { id: MARKET_MODELING_SCENARIO_CODES.CONSERVATIVE, label: 'Conservative' },
  { id: MARKET_MODELING_SCENARIO_CODES.MODERATE, label: 'Moderate' },
  { id: MARKET_MODELING_SCENARIO_CODES.OPTIMIZED, label: 'Optimized' },
  { id: MARKET_MODELING_SCENARIO_CODES.CUSTOM, label: 'Custom' },
]

export function resolveMarketModelingPersona(appSelected = '') {
  return appSelected?.toLowerCase() === 'app' ? MARKET_MODELING_PERSONAS.APP : MARKET_MODELING_PERSONAS.PHY
}

export function getMarketModelingTheme(persona = MARKET_MODELING_PERSONAS.PHY) {
  return PERSONA_THEMES[resolveMarketModelingPersona(persona)] || PERSONA_THEMES[MARKET_MODELING_PERSONAS.PHY]
}

export function getScenarioTabDefinitions(canUseCustom = true) {
  return canUseCustom
    ? SCENARIO_TAB_DEFINITIONS
    : SCENARIO_TAB_DEFINITIONS.filter(tab => tab.id !== MARKET_MODELING_SCENARIO_CODES.CUSTOM)
}
